import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'box-loader',
  templateUrl: './box-loader.component.html',
  styleUrls: ['./box-loader.component.scss']
})
/** loader que bloquea todos los componentes del campo sobre el cual se carga
 * @param mensaje: String, por defecto 'Aguarde...'
 */
 export class BoxLoaderComponent implements OnInit {
  @Input() mensaje: string = 'Aguarde... '
  constructor() { }


  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.calcMarging();
  }

  calcMarging(){
    let me = document.getElementsByClassName("i-loader-box");
    for (let index = 0; index < me.length; index++) {
      const el:any = me[index];
      let p = el.parentElement
      if(el && p){
        let h = p.clientHeight;
        el.style.marginTop = "min(30vh,"+ (h/2) +"px - 20px )"
      }
    }
  }

}

